/**
 * @generated SignedSource<<f2006bd040ed4988eb71fc33283f5678>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
import { FragmentRefs } from "relay-runtime";
export type OneOnOneLink_user$data = {
  readonly activeRecurring1on1Event: {
    readonly id: string;
  } | null;
  readonly email: string;
  readonly fullName: string;
  readonly hasReceivedInvites: boolean;
  readonly id: string;
  readonly image: string;
  readonly isActive: boolean;
  readonly isConfigured: boolean;
  readonly isGuest: boolean;
  readonly isTopUser: boolean;
  readonly relationshipToViewer: AncestryRelationship | null;
  readonly " $fragmentType": "OneOnOneLink_user";
};
export type OneOnOneLink_user$key = {
  readonly " $data"?: OneOnOneLink_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"OneOnOneLink_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OneOnOneLink_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isConfigured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasReceivedInvites",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "relationshipToViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTopUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "onlyReportManager",
          "value": true
        }
      ],
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "activeRecurring1on1Event",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": "activeRecurring1on1Event(onlyReportManager:true)"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "43d566f1000cf853564af2f565152cb2";

export default node;
